var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddConsent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "552px",
    height: "356px",
    viewBox: "0 0 552 356",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "addConsent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "addConsent",
    fill: "#6C757D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M537.5,232.75 L472.25,232.75 L472.25,167.5 C472.25,159.493281 465.756719,153 457.75,153 L443.25,153 C435.243281,153 428.75,159.493281 428.75,167.5 L428.75,232.75 L363.5,232.75 C355.493281,232.75 349,239.243281 349,247.25 L349,261.75 C349,269.756719 355.493281,276.25 363.5,276.25 L428.75,276.25 L428.75,341.5 C428.75,349.506719 435.243281,356 443.25,356 L457.75,356 C465.756719,356 472.25,349.506719 472.25,341.5 L472.25,276.25 L537.5,276.25 C545.506719,276.25 552,269.756719 552,261.75 L552,247.25 C552,239.243281 545.506719,232.75 537.5,232.75 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.446891,349.008172 L7.29308989,193.854371 C-2.02825956,184.533022 -2.02825956,169.419512 7.29308989,160.09723 L41.0492982,126.34009 C50.3706476,117.017808 65.4850894,117.017808 74.8064388,126.34009 L179.325461,230.85818 L403.193561,6.99101209 C412.514911,-2.33033736 427.629352,-2.33033736 436.950702,6.99101209 L470.70691,40.7481528 C480.02826,50.0695022 480.02826,65.1830116 470.70691,74.5052934 L196.204032,349.009104 C186.88175,358.330454 171.76824,358.330454 162.446891,349.008172 L162.446891,349.008172 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddConsent);
export default __webpack_public_path__ + "static/media/addConsent.8fdc4887b7d69462fd79e2d1b389ba06.svg";
export { ForwardRef as ReactComponent };